import { styled, Text } from "@sourceful/shared-components";
import StandardLink from "@components/siteHeader/StandardLink";
import toRem from "@styles/postprocess/conversion/to-rem";
import { StandardLink as StandardLinkType } from "@sourceful/shared-types/src/sanity/links";

export interface LogosBlockProps {
  keyPrefix?: string;
  logos: LogoType[];
  title: string;
  isRightAligned?: boolean;
}

interface LogoType {
  image: {
    url: string;
    alt: string;
    link?: StandardLinkType;
  };
}

const LogosBlockWrapper = styled("div", {});

const SecondaryWrapper = styled("div", {
  paddingTop: "1rem",
  maxWidth: "80rem",
});

const BlockWrapper = styled("div", {
  display: "flex",
  flexWrap: "wrap",
  paddingTop: "0.25rem",
});

const Logo = styled("img", {
  width: toRem(70),
  height: "auto",
  aspectRatio: "1/1",
  mie: "$inline_m2",
  objectFit: "contain",

  "&:last-child": {
    mie: "0",
  },
});

export default function LogosBlock({ keyPrefix, title, logos, isRightAligned }: LogosBlockProps) {
  return (
    <LogosBlockWrapper>
      <SecondaryWrapper css={{ textAlign: isRightAligned ? "right" : "left" }}>
        <Text level={2} prominence="secondary" css={{ color: "$primary_100" }}>
          {title}
        </Text>
        <BlockWrapper css={{ justifyContent: isRightAligned ? "flex-end" : "flex-start" }}>
          {logos.map((logo, index) => {
            if (logo?.image?.link) {
              return (
                <StandardLink
                  key={`${keyPrefix}${index}`}
                  internalLink={logo?.image?.link.internalLink}
                  externalLink={logo?.image?.link.externalLink}
                >
                  <Logo
                    src={logo.image.url}
                    alt={logo.image.alt}
                    loading="lazy"
                    width="70"
                    height="70"
                  />
                </StandardLink>
              );
            }
            return (
              <Logo
                src={logo.image.url}
                alt={logo.image.alt}
                key={`${keyPrefix}${index}`}
                loading="lazy"
                width="70"
                height="70"
              />
            );
          })}
        </BlockWrapper>
      </SecondaryWrapper>
    </LogosBlockWrapper>
  );
}
